// =====================================================================
// Helper di stampa PDF (D10B). Riusa la response di un endpoint di download
// (responseType: "blob") e apre il PDF in una finestra dedicata, lanciando la
// stampa del browser. NON rigenera il documento e non crea record.
//
// Lancia un Error con message "POPUP_BLOCKED" se la finestra non si apre
// (popup bloccati): il chiamante mostra un messaggio leggibile.
// =====================================================================

const POPUP_BLOCKED = "POPUP_BLOCKED";

// `response` è la risposta axios con responseType "blob" (response.data = Blob).
export const printPdfFromResponse = (response) => {
  const data = response && response.data ? response.data : response;
  const blob =
    data instanceof Blob ? data : new Blob([data], { type: "application/pdf" });
  return printPdfBlob(blob);
};

export const printPdfBlob = (blob) => {
  const pdfBlob =
    blob.type === "application/pdf"
      ? blob
      : new Blob([blob], { type: "application/pdf" });
  const url = window.URL.createObjectURL(pdfBlob);

  const win = window.open(url, "_blank");
  if (!win) {
    window.URL.revokeObjectURL(url);
    throw new Error(POPUP_BLOCKED);
  }

  // Stampa una sola volta: onload se disponibile, con fallback a timer per i
  // visualizzatori PDF che non emettono "load" in modo affidabile.
  let printed = false;
  const triggerPrint = () => {
    if (printed) return;
    printed = true;
    try {
      win.focus();
      win.print();
    } catch {
      // Alcuni viewer PDF gestiscono la stampa internamente: nessun blocco.
    }
  };

  win.onload = triggerPrint;
  window.setTimeout(triggerPrint, 1500);
  // Rilascia l'URL dopo che la stampa è stata avviata.
  window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);

  return win;
};

// Apre il PDF in una nuova scheda SENZA lanciare la stampa (azione "Visualizza").
// `response` è la risposta axios con responseType "blob" (response.data = Blob).
export const openPdfFromResponse = (response) => {
  const data = response && response.data ? response.data : response;
  const blob =
    data instanceof Blob ? data : new Blob([data], { type: "application/pdf" });
  return openPdfBlob(blob);
};

export const openPdfBlob = (blob) => {
  const pdfBlob =
    blob.type === "application/pdf"
      ? blob
      : new Blob([blob], { type: "application/pdf" });
  const url = window.URL.createObjectURL(pdfBlob);

  const win = window.open(url, "_blank");
  if (!win) {
    window.URL.revokeObjectURL(url);
    throw new Error(POPUP_BLOCKED);
  }
  // Rilascia l'URL dopo che la scheda ha avuto tempo di caricare il PDF.
  window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  return win;
};

export const isPopupBlocked = (err) => err && err.message === POPUP_BLOCKED;

export const POPUP_BLOCKED_MESSAGE =
  "Impossibile aprire la finestra di stampa. Controlla il blocco popup del browser.";
